var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.25 33L56.54 25.3275L57.475 15.18L47.5475 12.925L42.35 4.125L33 8.14L23.65 4.125L18.4525 12.8975L8.525 15.125L9.46 25.3L2.75 33L9.46 40.6725L8.525 50.8475L18.4525 53.1025L23.65 61.875L33 57.8325L42.35 61.8475L47.5475 53.075L57.475 50.82L56.54 40.6725L63.25 33ZM25.795 44.0275L19.25 37.4275C18.1775 36.355 18.1775 34.6225 19.25 33.55L19.4425 33.3575C20.515 32.285 22.275 32.285 23.3475 33.3575L27.775 37.8125L41.9375 23.6225C43.01 22.55 44.77 22.55 45.8425 23.6225L46.035 23.815C47.1075 24.8875 47.1075 26.62 46.035 27.6925L29.755 44.0275C28.6275 45.1 26.895 45.1 25.795 44.0275Z",
    fill: "#FFDE33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/Verified.8102ee956ae9f45cd89bb2d07a7840c3.svg";
export { ForwardRef as ReactComponent };